import React, { Component } from 'react';
import './Contacts.css';
import { Row, Col, Input, Card, CardHeader, CardBody, Collapse } from 'reactstrap';
import ContactForm from './ContactForm';
// import ListContacts from './ListContacts';
// import EditContact from './EditContact';
// import AddContact from './AddContact';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChevronDown, faChevronUp } from '@fortawesome/free-solid-svg-icons';
import CompanyContext from '../../auth/CompanyContext';
import { Prompt } from 'react-router-dom';

class Contacts extends Component {
    static contextType = CompanyContext;

    constructor(props) {

        super(props);
        this.state = {
            secID: this.props.secID,
            orgID: this.props.orgID,
            isLoading: true,
            contacts: [],
            notesCategories: [],
            debug_message: null,
            prevLinkedID: null,
            addCategoryCommentsArray: [],
            editCategoryCommentsArray: [],
            selectValue: '',
            editID: 0,
            open: true,
            unsavedChanges: false
        };
    }


    componentDidMount() {
        this.setState(
            { isLoading: true },
            () => {
                this.getContacts();
                if (this.props.useProvidedNotesCategories) {
                    this.setState({ notesCategories: Array.isArray(this.props.notesCategories) ? this.props.notesCategories : [] });
                } else if (Array.isArray(this.props.notesCategories) && this.props.notesCategories.length > 0) {
                    this.setState({ notesCategories: this.props.notesCategories });
                } else {
                    this.getNotesCategories();
                }
            }
        );
        this.props.setContactsHandleAdd(this.handleAddSubmit);
    }

    componentDidUpdate(prevProps, prevState) {
        if (JSON.stringify(this.props.searchOptions) !== JSON.stringify(prevProps.searchOptions)) {
            this.setState(
                { isLoading: true },
            );
        }
        const didUserChange = this.props.user !== prevProps.user;
        const didTokenChange = this.props.clientToken !== prevProps.clientToken;
        const didSecIDChange = this.props.secID !== prevProps.secID;
        if ((didUserChange || didTokenChange || didSecIDChange) && this.props.user && this.props.clientToken && this.props.secID) {
            this.getContacts();
        }
        if (this.props.notesCategories !== prevProps.notesCategories && Array.isArray(this.props.notesCategories)) {
            this.setState({ notesCategories: this.props.notesCategories });
        }
        if (prevState.contacts !== this.state.contacts) {
            this.props.setContacts(this.state.contacts);
        }
    }

    parseNdjsonStream = async ({ response, onRow, signal }) => {
        const reader = response.body.getReader();
        const decoder = new TextDecoder();
        let leftover = "";

        while (true) {
            if (signal?.aborted) break;
            const { value, done } = await reader.read();
            if (done) break;

            const chunk = decoder.decode(value, { stream: true });
            const text = leftover + chunk;
            const lines = text.split("\n");
            leftover = lines.pop() || ""; // save last partial line

            for (const line of lines) {
                const trimmed = line.trim();
                if (!trimmed) continue;
                try {
                    const obj = JSON.parse(trimmed);
                    if (onRow) onRow(obj);
                } catch {
                    // ignore malformed lines (or log)
                }
            }
        }

        // flush any final full line
        const tail = leftover.trim();
        if (tail) {
            try {
                const obj = JSON.parse(tail);
                if (onRow) onRow(obj);
            } catch { }
        }
    };

    handleAddSubmit = () => {
        console.log('Contacts.js/handleAddSubmit')
        let dataObj = {};
        let active = true;
        this.props.addCategoryCommentsArray.filter(item => item.value !== '' && item.value != null).forEach(item => {
            if (item.type === 'Inactive' && (item.value === 1 || Boolean(item.value))) {
                active = false;
            } else {
                dataObj[item.type] = item.value;
            }
        })
        this.setState({
            isLoading: true
        }, () => {
            fetch('/api/contacts/', {
                method: 'POST',
                body: JSON.stringify({
                    data: JSON.stringify(dataObj),
                    auth0: this.props.user,
                    active: active,
                    secID: this.state.secID
                }),
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + this.props.clientToken,
                    'X-Database': this.context.company
                }
            })
                .then(results => results.json())
                .then(results => {
                    if (results.debug_message == null) {
                        this.props.handleCancel();
                        this.getContacts();
                        this.props.setUnsavedChanges(false);
                    }
                });
        }
        );

    }

    handleCancel = (e) => {
        // console.log('Contacts.js/handleCancel (e)', e.target.name, e.target.value)
        this.setState(
            {
                selectValue: '',
                isLoading: false,
                // addCategoryCommentsArray: [],
                editCategoryCommentsArray: []
            }, () => {
                this.getContacts();
                this.props.setUnsavedChanges(false);
            }
        );
    }

    handleEditSubmit = (e) => {
        console.log('Contacts.js/handleEditSubmit (e)', e.target.name, e.target.value);
        let dataObj = {};
        let active = true;
        this.state.editCategoryCommentsArray.filter(item => item.value !== '' && item.value != null).forEach(item => {
            if (item.type === 'Inactive' && (item.value === 1 || Boolean(item.value))) {
                active = false;
            } else {
                dataObj[item.type] = item.value;
            }
        })
        this.setState(
            { isLoading: true },
        );
        fetch('/api/contacts/' + e.target.value, {
            method: 'PUT',
            body: JSON.stringify({
                data: JSON.stringify(dataObj),
                auth0: this.props.user,
                active: active
            }),
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.props.clientToken,
                'X-Database': this.context.company
            }
        })
            .then(results => results.json())
            .then(results => {
                if (results.debug_message == null) {
                    // this.handleDelete({ target: { value: results.linkedID } });
                    this.setState({
                        editID: 0,
                        editCategoryCommentsArray: []
                    }, () => {
                        this.getContacts();
                        this.props.setUnsavedChanges(false);
                    })
                }
            });
    }

    handleDelete = (e) => {
        // console.log('Contacts.js/handleDelete (e)', e.target.name, e.target.value)
        fetch('/api/contacts/' + e.target.value, {
            method: 'DELETE',
            //body: json_request,
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.props.clientToken,
                'X-Database': this.context.company
            }
        })
            .then(results => results.json())
            .then(results => {
                if (results.debug_message == null) {
                    this.setState(
                        { editID: 0, isLoading: false },
                        () => {
                            this.getContacts();
                            this.props.setUnsavedChanges(false);
                        }
                    );
                }
            });
    }

    handleEditSwap = (val) => {
        // console.log('Contacts.js/handleEditSwap (val)', val)
        this.displayEditCategories(val);
        this.props.setUnsavedChanges(false);
        this.setState({
            otherCategories: {},
            editID: val !== this.state.editID ? val : 0
        });
    }

    getNotesCategories() {
        if (this.props.useProvidedNotesCategories) {
            this.setState({
                isLoading: false,
                notesCategories: Array.isArray(this.props.notesCategories) ? this.props.notesCategories : []
            });
            return;
        }
        if (Array.isArray(this.props.notesCategories) && this.props.notesCategories.length > 0) {
            this.setState({
                isLoading: false,
                notesCategories: this.props.notesCategories
            });
            return;
        }
        // console.log('Contacts.js/getNotesCategories')
        fetch('/api/notesCategories/', {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.props.clientToken,
                'X-Database': this.context.company
            }
        })
            .then(results => results.json())
            .then(results => {
                this.setState({
                    isLoading: false,
                    notesCategories: results.data.filter(item => item.type === 'Contact')[0].children,
                    debug_message: results.debug_message,
                });
            });
        return;
    }

    getContacts = (cb) => {
        if (!this.props.user || !this.props.clientToken || !this.props.secID) {
            this.setState({ isLoading: false, contacts: [] }, () => cb && cb());
            return;
        }

        if (this.abortController) {
            this.abortController.abort();
        }
        this.abortController = new AbortController();

        this.setState({ isLoading: true, contacts: [] },
            async () => {
                const headers = {
                    'Accept': 'application/x-ndjson',   // <-- tell server we want NDJSON
                    'Authorization': 'Bearer ' + this.props.clientToken,
                    'X-Database': this.context.company
                };

                const resp = await fetch(`/api/contacts/${this.props.user}/${this.props.secID}`, {
                    method: 'GET',
                    headers,
                    signal: this.abortController.signal
                });

                if (!resp.ok || !resp.body) {
                    this.setState({ isLoading: false });
                    return;
                }

                const buffer = [];
                let raf = null;
                const flush = () => {
                    if (!buffer.length) return;
                    this.setState(prev => ({ contacts: prev.contacts.concat(buffer.splice(0)) }));
                    raf = null;
                };

                await this.parseNdjsonStream({
                    response: resp,
                    signal: this.abortController.signal,
                    onRow: (row) => {
                        buffer.push(row);
                        if (!raf) raf = requestAnimationFrame(flush);
                    }
                });

                if (buffer.length) {
                    this.setState(prev => ({ contacts: prev.contacts.concat(buffer.splice(0)) }));
                }

                this.setState({ isLoading: false }, () => cb && cb());

            });
    }

    displayCategories = (e) => {
        // console.log('Contacts.js/displayCategories (e)', e.target.name, e.target.value)
        const categoryList = typeof (this.state.notesCategories.filter(
            item => parseInt(item.ID) === parseInt(e.target.value)
        )[0]) !== 'undefined' ? this.state.notesCategories.filter(
            item => parseInt(item.ID) === parseInt(e.target.value)
        )[0].children : [];
        categoryList.forEach((item) => { item.value = null; })
        const categoryValue = parseInt(e.target.value);
        this.setState({
            selectValue: categoryValue,
            // addCategoryCommentsArray: categoryList
        });
    };

    displayEditCategories = (val) => {
        // console.log('Contacts.js/displayEditCategories (val)', val)
        const dataList = typeof (this.state.contacts.filter(
            item => item.linkedID === val
        )[0]) !== 'undefined' ? this.state.contacts.filter(
            item => item.linkedID === val
        )[0] : [];
        const categoryList = this.state.notesCategories/*.filter(
            item => Object.keys(dataList.children).findIndex(key => key === item.type) > -1
        );*/
        categoryList.forEach(item => {
            const matchData = Object.keys(dataList.children).filter(key => key === item.type);
            if (matchData.length > 0) {
                item.value = dataList.children[matchData[0]];
                // item.commentID = matchData[0].ID;
                // item.parentID = matchData[0].parentID;
                // item.error = false;
            } else {
                item.value = "";
                // item.commentID = null;
                // item.parentID = null;
                // item.error = false;
            }
        })
        if (categoryList.findIndex(item => item.type === "Inactive") > -1) {
            categoryList[categoryList.findIndex(item => item.type === "Inactive")].value = !dataList.active;
        }
        // console.log(dataList, categoryList)
        this.setState({
            editCategoryCommentsArray: categoryList
        });
    };

    setComment = (e) => {
        // console.log('Contacts.js/setComment (e)', e.target.name, e.target.value)
        const commentsArray = [...this.props.addCategoryCommentsArray];
        commentsArray.filter(
            item => parseInt(item.ID) === parseInt(e.target.name)
        )[0].value = e.target.value;
        // this.setState({
        //     addCategoryCommentsArray: commentsArray
        // });
        this.props.setUnsavedChanges(true);
    }

    setEditComment = (e) => {
        // console.log('Contacts.js/setEditComment (e)', e.target.name, e.target.value)
        const commentsArray = [...this.state.editCategoryCommentsArray];
        commentsArray.filter(
            item => parseInt(item.ID) === parseInt(e.target.name)
        )[0].value = e.target.value;
        //dataArray.filter(item => parseInt(item.ID) === parseInt(e.target.name))[0]
        this.setState({
            editCategoryCommentsArray: commentsArray
        });
        this.props.setUnsavedChanges(true);

    }

    changeComment = (e, validation = null) => {
        const dataArray = [...this.state.editCategoryCommentsArray];
        const targetID = parseInt(e.target.name);
        const field = dataArray.find(item => parseInt(item.ID) === targetID);

        // console.log('Contacts.js/changeComment (e)', e.target.name, e.target.value, validation, dataArray);

        if (!field) return;

        // Set value based on input type
        if (e.target.type === 'select-multiple') {
            field.value = Array.from(e.target.selectedOptions, option => option.value);
        } else if (e.target.type === 'checkbox') {
            field.value = e.target.checked;
        } else {
            field.value = e.target.value;
        }

        // Validation logic
        if (validation != null) {
            const valueToValidate = Array.isArray(field.value) ? field.value.join(',') : String(field.value);
            const matches = valueToValidate.match(new RegExp(validation));
            field.error = matches == null;
        }

        // Clear error if value is empty
        if (field.value === '' || field.value == null || (Array.isArray(field.value) && field.value.length === 0)) {
            field.error = false;
        }

        this.setState({
            editCategoryCommentsArray: dataArray
        });

        this.props.setUnsavedChanges(true);
    };

    isFormBlank(array) {
        // console.log('Contacts.js/isFormBlank (array)', array)
        let retBool = true;
        array.forEach(row => {
            if (row.value !== null && row.value !== '') { retBool = false; }
        })
        return retBool;
    }

    showHide() {
        // console.log('Contacts.js/showHide')
        this.setState({
            open: !this.state.open
        })
    }

    render() {
        return (<>
            <Prompt
                when={this.state.unsavedChanges}
                message="You have unsaved changes, are you sure you want to leave?"
            />
            {this.state.contacts.length > 0 && <Card>
                <CardHeader onClick={() => this.showHide()}>
                    <Row className="align-items-center">
                        <Col className="text-left">
                            <h3>Contacts</h3>
                        </Col>
                        {this.state.contacts.findIndex(item => !item.active) > -1 && <Col className="col-xs-4 text-right" onClick={(e) => e.stopPropagation()} >
                            <Input
                                type="checkbox"
                                checked={this.state.showInactiveContacts}
                                onClick={() => this.setState({ showInactive: !this.state.showInactive })}
                            /> Show Inactive
                        </Col>}
                        <Col xs="1" className="text-right">
                            {(this.state.open) ? <FontAwesomeIcon icon={faChevronUp} /> : <FontAwesomeIcon icon={faChevronDown} />}
                        </Col>
                    </Row>
                </CardHeader>
                <Collapse isOpen={this.state.open}>
                    <CardBody>
                        <ContactForm
                            clientToken={this.props.clientToken}
                            history={this.props.history}
                            editID={this.state.editID}
                            contacts={[...this.state.contacts].filter(row => (this.state.showInactive || (!this.state.showInactive && row.active)))}
                            notesCategories={this.state.notesCategories}
                            justNotes={false}
                            // addCategoryCommentsArray={this.state.addCategoryCommentsArray}
                            editCategoryCommentsArray={this.state.editCategoryCommentsArray}
                            selectValue={this.state.selectValue}
                            otherCategories={this.state.otherCategories}
                            onGetMetaData={this.onGetMetaData}
                            handleCancel={this.handleCancel}
                            handleAddSubmit={this.handleAddSubmit}
                            handleEditSubmit={this.handleEditSubmit}
                            handleDelete={this.handleDelete}
                            handleEditSwap={this.handleEditSwap}
                            displayCategories={this.displayCategories}
                            displayEditCategories={this.displayEditCategories}
                            setComment={this.setComment}
                            setEditComment={this.setEditComment}
                            changeComment={this.changeComment}
                            changeOtherCategory={this.changeOtherCategory}
                            addCategory={this.addCategory}
                            setUnsavedChanges={this.props.setUnsavedChanges}
                            userPermissions={this.props.userPermissions}
                            user={this.props.user}
                        // marketingActivities={this.state.marketingActivities.filter(activity => activity.Category === 'Emails')}
                        />
                    </CardBody>
                </Collapse>
            </Card>}
        </>
        );
    }
}



export default Contacts;
